import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { WritableComputedRef, computed } from "vue";
import TwLabel from "../TwLabel.vue";
import TwRadioButton from "../TwRadioButton.vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: '6.SkinType',
  setup(__props) {

const store = useStore();

const skinType: WritableComputedRef<string> = computed({
  get: () => store.state.form.skin_type,
  set: (value) => store.dispatch("updateSkinType", value),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[skinType.value == null ? 'bg-red-500' : ''], "p-2"])
  }, [
    _createVNode(TwLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("what_type_skin_do_you_have")), 1)
      ]),
      _: 1
    }),
    _createVNode(TwRadioButton, {
      name: "skin_type",
      modelValue: skinType.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((skinType).value = $event)),
      options: [
        { label: _ctx.$t('normal'), value: 'normal' },
        { label: _ctx.$t('oily'), value: 'oily' },
        { label: _ctx.$t('dry'), value: 'dry' },
        { label: _ctx.$t('combination'), value: 'combination' },
      ]
    }, null, 8, ["modelValue", "options"])
  ], 2))
}
}

})